<template>
  <div class="container">
    <table></table>
    <van-swipe @change="onChange" :loop="true" width="100vw" height="60vw">
      <van-swipe-item v-for="item in imglist" :key="item.index">
        <img :src="item" alt="" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{ total }}</div>
      </template>
    </van-swipe>
    <div class="main">
      <div class="flex">
        <p style="color: #ee754a; font-size: 24px; font-weight: bold">
          {{ obj.score }}积分
        </p>
        <div class="bt01" v-if="obj.type_front == 1">实物</div>
        <div class="bt01" v-else-if="obj.type_front == 2">虚拟</div>
        <div class="bt01" v-else-if="obj.type_front == 3">积分</div>
      </div>
      <p class="title">{{ obj.title }}</p>
      <p style="color: #858585">剩余:{{ obj.storage }}件</p>
    </div>
    <div class="main">
      <p class="title">兑换注意事项</p>
      <div class="text" v-html="obj.notice"></div>
    </div>
    <div class="main">
      <p class="title">礼品介绍</p>
      <div class="text" v-html="obj.des"></div>
    </div>
    <div
      class="bt02"
      @click="exchange()"
      v-if="timest() > obj.begintime && obj.storage > 0"
    >
      立即兑换
    </div>
    <div
      class="bt02"
      v-else-if="timest() > obj.begintime && obj.storage <= 0"
      style="background: #858585"
    >
      已抢光
    </div>
    <div
      class="bt02"
      v-else
      style="background: #f8f6ef; color: #cab586; border: 1px solid #cab586"
    >
      即将开放
    </div>
    <table></table>
  </div>
</template>
<script>
export default {
  name: "jfgoodsdetail",
  data() {
    return {
      obj: {},
      imglist: [],
      current: 0,
      state: "",
      total: 1,
    };
  },
  mounted() {
    this.$toast.loading({
      duration: 0,
      forbidClick: true,
    });
    this.$axios({
      method: "post",
      url: "/api/score/goodinfo",
      data: this.qs.stringify({
        good_id: this.$route.query.id,
      }),
    }).then((res) => {
      this.$toast.clear();
      if (res.data.code != 0) {
        this.$toast(res.data.msg);
      } else {
        this.obj = res.data.data;
        this.imglist = this.obj.imgs.split(",");
        this.total = this.imglist.length;
      }
    });
  },
  methods: {
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    onChange(index) {
      console.log(index);
      this.current = index;
    },
    exchange() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      this.$axios({
        method: "post",
        url: "/api/score/beforebuy",
        data: this.qs.stringify({
          good_id: this.$route.query.id,
        }),
      }).then((res) => {
        if (res.data.code != 0) {
          this.$toast(res.data.msg);
        } else {
          this.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          this.$axios({
            method: "post",
            url: "/api/score/buy",
            data: this.qs.stringify({
              good_id: this.$route.query.id,
            }),
          }).then((res) => {
            if (res.data.code != 0) {
              this.$toast(res.data.msg);
            } else {
              this.$toast("兑换成功");
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  background: #f5f5f5;
  min-height: 100vh;
}
.main {
  background: white;
  margin: 10px;
  border-radius: 10px;
  padding: 15px;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.bt01 {
  color: white;
  width: 82px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  background: #cab586;
  border-radius: 4px;
}
.title {
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: bold;
}
.bt02 {
  margin: 38px;
  color: white;
  background: #cab586;
  border-radius: 4px;
  height: 44px;
  line-height: 44px;
  text-align: center;
}
.text /deep/ img {
  width: 100% !important;
  display: block;
  padding: 10px 0;
}
.text /deep/ video {
  width: 100% !important;
  padding: 10px 0;
  background: black;
}
.text /deep/ audio {
  width: 100% !important;
  padding: 10px 0;
}
.text /deep/ iframe {
  width: 100% !important;
  height: 55vw !important;
}
.text /deep/ embed {
  width: 100% !important;
}
.text /deep/ span {
  max-width: 100%;
}
.van-swipe {
  width: 100%;
  height: 60vw;
}
.van-swipe img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/jfgoodsdetail.vue